import { Component, Input, OnInit } from '@angular/core';
import { MainFilterClass } from '../main-filter';

@Component({
  selector: 'app-text-filter',
  templateUrl: './text-filter.component.html',
  styleUrls: ['./text-filter.component.less'],
})
export class TextFilterComponent extends MainFilterClass implements OnInit {

@Input() fieldFilterOprs:any;

ngOnInit(): void {
}

}
